import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import { useIsClientPortalAdminUser } from '../../../hooks/useIsClientPortalAdminUser';
import { useIsClientPortalUser } from '../../../hooks/useIsClientPortalUser';
import PageHeader from '../../controls/PageHeader';

interface PassengerHeaderProps {
  name: string;
  createDisabled: boolean;
  createHidden?: boolean;
  onCreateTrip: () => void;
}

export default function PassengerHeader({
  name,
  createDisabled,
  createHidden,
  onCreateTrip,
}: PassengerHeaderProps) {
  const t = useCommonTranslation();

  const isPortalUser = useIsClientPortalUser() || useIsClientPortalAdminUser();
  const returnLinkText = isPortalUser
    ? t('passenger.searchTitle')
    : t('common.back');

  return (
    <PageHeader
      title={name}
      returnLink="/passengers"
      returnLinkText={returnLinkText}
      primaryActionText={createHidden ? undefined : t('passenger.createTrip')}
      primaryActionDisabled={createDisabled}
      onPrimaryAction={onCreateTrip}
    />
  );
}
